import { Tag } from '@ardoq/status-ui';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { ResolvedComponentIcon } from './ResolvedComponentIcon';
import { APIComponentAttributes } from '@ardoq/api-types';
import { EnhancedScopeData } from '@ardoq/data-model';

export type ComponentTypeTagWithIconProps = {
  component: APIComponentAttributes;
  scopeData: EnhancedScopeData;
};

const ComponentTypeTagWithIcon = ({
  component,
  scopeData,
}: ComponentTypeTagWithIconProps) => (
  <Tag>
    <FlexBox gap="xsmall" align="center">
      <ResolvedComponentIcon component={component} scopeData={scopeData} />
      <Text truncate>{component.type}</Text>
    </FlexBox>
  </Tag>
);

export { ComponentTypeTagWithIcon };
